module.exports = __webpack_public_path__ + "static/media/crop-alt.6fb53bf0.svg";